module.exports = __webpack_public_path__ + "fonts/MessinaSansWeb-BoldItalic.4964e6d1.woff2";